(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahv-premium-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  const media=window.matchMedia('(max-width:767px)');
  const sync=()=>document.querySelectorAll('.ahv-pf details').forEach((item)=>{if(media.matches){item.removeAttribute('open')}else{item.setAttribute('open','')}});
  sync();
  if(media.addEventListener){media.addEventListener('change',sync)}else{media.addListener(sync)}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-clone-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rv-product]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const mainImage = root.querySelector('.rv-shrine-main-image');
      root.querySelectorAll('[data-rv-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = button.dataset.src;
          mainImage.srcset = '';
          mainImage.alt = button.dataset.alt || '';
          root.querySelectorAll('[data-rv-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
          button.classList.add('is-active');
        });
      });

      const quantity = root.querySelector('input[name="quantity"]');
      root.querySelector('[data-rv-qty-minus]')?.addEventListener('click', () => quantity?.stepDown());
      root.querySelector('[data-rv-qty-plus]')?.addEventListener('click', () => quantity?.stepUp());

      const source = root.querySelector('[data-rv-spec-source]');
      const list = root.querySelector('[data-rv-spec-list]');
      if (source && list) {
        source.querySelectorAll('[class*="row-"]').forEach((row) => {
          const strong = row.querySelector('strong');
          if (!strong) return;
          let label = strong.textContent.replace(/:\s*$/, '').trim();
          if (label.toLowerCase() === 'ira approved') label = 'IRA Approved';
          const clone = row.cloneNode(true);
          clone.querySelectorAll('strong').forEach((node) => node.remove());
          let value = clone.textContent.replace(/^[\s:]+/, '').trim();
          if (label === 'Origin' && value === 'Canadian') value = 'Canada';
          if (!label || !value) return;
          const item = document.createElement('div');
          item.className = 'rv-shrine-specification-row';
          const term = document.createElement('dt');
          term.className = 'rv-shrine-specification-label';
          term.textContent = label;
          const detail = document.createElement('dd');
          detail.className = 'rv-shrine-specification-value';
          detail.textContent = value;
          item.append(term, detail);
          list.append(item);
        });
      }
    });

    document.querySelectorAll('[data-rv-recommendations-url]').forEach((recommendationSection) => {
      if (recommendationSection.dataset.ready === 'true') return;
      recommendationSection.dataset.ready = 'true';
      fetch(recommendationSection.dataset.rvRecommendationsUrl)
        .then((response) => response.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const recommendedGrid = parsed.querySelector('.rv-source-related__grid');
          const currentGrid = recommendationSection.querySelector('.rv-source-related__grid');
          if (recommendedGrid?.children.length && currentGrid) currentGrid.innerHTML = recommendedGrid.innerHTML;
        })
        .catch(() => {});
    });

    document.querySelectorAll('[data-rv-tabs]').forEach((tabs) => {
      if (tabs.dataset.ready === 'true') return;
      tabs.dataset.ready = 'true';
      tabs.querySelectorAll('[data-rv-tab]').forEach((button) => {
        button.addEventListener('click', () => {
          tabs.querySelectorAll('[data-rv-tab]').forEach((tab) => {
            tab.classList.remove('is-active');
            tab.setAttribute('aria-selected', 'false');
          });
          tabs.querySelectorAll('[data-rv-panel]').forEach((panel) => panel.classList.remove('is-active'));
          button.classList.add('is-active');
          button.setAttribute('aria-selected', 'true');
          tabs.querySelector(`[data-rv-panel="${button.dataset.rvTab}"]`)?.classList.add('is-active');
        });
      });
    });

    const reviewSection = document.querySelector('.rv-product-reviews');
    const reviewWidget = reviewSection?.querySelector('.rv-product-reviews__widget');
    if (reviewSection && reviewWidget) {
      const syncReviewVisibility = () => {
        const renderedChildren = Array.from(reviewWidget.children).some((child) => child.getBoundingClientRect().height > 1);
        const hasReviewContent = Boolean(
          reviewWidget.querySelector('iframe') ||
          renderedChildren ||
          reviewWidget.textContent.trim()
        );
        reviewSection.hidden = !hasReviewContent;
        if (hasReviewContent) reviewObserver.disconnect();
      };
      const reviewObserver = new MutationObserver(syncReviewVisibility);
      reviewObserver.observe(reviewWidget, { childList: true, subtree: true, characterData: true });
      syncReviewVisibility();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
